import React from 'react';
import ReleaseCard from './ReleaseCard';

export default function ReleaseV1100({ createThumbnail }) {
  return (
    <ReleaseCard version="v1.10.0" date="29th April 2026" title="More flexibility, more polish!">
      <p className="text-gray-300 mb-4">This release is all about giving you more control and making things feel even smoother. Here's what's new:</p>
      <div className="mb-6">
        <h5 className="text-lg font-medium text-purple-400 mb-2">Manual Prize Entries</h5>
        <p className="text-gray-300 mb-4">
          Need to add a custom prize that doesn't fit the standard structure? Now you can manually add prize entries, giving you full control over how winnings are distributed.
        </p>

        <h5 className="text-lg font-medium text-purple-400 mb-2">Chop Tools — Anytime, Anywhere</h5>
        <p className="text-gray-300 mb-4">
          The popular chop calculator is no longer tied to an active game. Access it directly from the tools menu whenever you need to work out a deal — perfect for settling up after the fact or planning ahead.
        </p>

        <h5 className="text-lg font-medium text-purple-400 mb-2">GPS Venue Address</h5>
        <p className="text-gray-300 mb-4">
          Setting up a new venue just got easier. Poppy Poker can now populate your venue address automatically based on your GPS location — no more typing it out manually.
        </p>

        <h5 className="text-lg font-medium text-purple-400 mb-2">UI Polish & Under-the-Hood Improvements</h5>
        <p className="text-gray-300 mb-4">
          Several page layouts have been refined for a cleaner, more professional look. We've also updated the underlying framework to keep things running fast and secure.
        </p>
      </div>
    </ReleaseCard>
  );
}
